export const showLoading = (visible) => ({
  type: 'SHOW_LOADING',
  visible
})
